module.exports = __webpack_public_path__ + "img/rocket.b4b138a6.svg";